"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DividerDecorative = void 0;
var DividerDecorative_1 = require("./DividerDecorative");
Object.defineProperty(exports, "DividerDecorative", { enumerable: true, get: function () { return DividerDecorative_1.DividerDecorative; } });
